import SuspenseLoading from './SuspenseLoading';

export default SuspenseLoading;
